// Only the weights the design uses, latin only, self-hosted through npm: a font
// fetched from a CDN on the sign-in screen would tell a third party who is
// signing in, and when.
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';

import { createRoot } from 'react-dom/client';

import { App } from './components/app';

// The browser entry mounts the application into the document's empty root.
// Nothing is hydrated: the server rendered only the document around it.
createRoot(document.getElementById('root')).render(<App/>);
